import { render } from "./XMultipleSelect.vue?vue&type=template&id=39c0667e"
import script from "./XMultipleSelect.vue?vue&type=script&lang=js"
export * from "./XMultipleSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__